// extracted by mini-css-extract-plugin
export default {"onClickTd":"ListItem_onClickTd__mg11u"};